<template>
  <div class="document">
    <div class="header">
      <es-header>
        <template #header>
          <div class="header-title">My Activity</div>
        </template>
      </es-header>
    </div>
    <div class="activity-row">
      <es-loader v-if="loading" size="2x" style="padding: 0.5rem 0"/>
      <es-exception
        v-else-if="loadingError"
        style="margin: 1rem"
        exceptionMessage="There was an issue loading the report data.
          Please try again or contact your administrator."/>
      <div v-else class="activity-row-container">
        <div class="icon-column">
          <div class="activity-element">
            <font-awesome-icon
              :icon="['fas', `clipboard-user`]"
              size="2x"
              class="text-muted"/>
          </div>
        </div>
        <div v-if="reportData && reportData.endDate" class="activity-summary">
          <div class="activity-status activity-element">
            <span class="has-text-weight-bold">
              The CEP Roster CSV
            </span>
            is ready to download
          </div>
          <div class="activity-summary">
            <div class="activity-element">
              <a @click.prevent="downloadReport($event)">
                <font-awesome-icon
                  :icon="['fal', 'arrow-circle-down']"
                  size="lg"
                  class="ml-1 mr-1" />
                <span>Start download</span>
              </a>
            </div>
            <div class="activity-element">
              <font-awesome-icon
                :icon="['fas', 'clock']"
                size="lg"
                class="ml-1 mr-1 text-muted" />
                {{ reportData.endDate | formatDateMMDDYYYYHHMM }}
            </div>
          </div>
        </div>
        <div v-else-if="reportData" class="activity-summary">
          <div class="activity-status activity-element">
            <span class="has-text-weight-bold">
              The CEP Roster CSV
            </span>
            is generating. Click
            <a @click="getLatestCepRosterReport()">
              <font-awesome-icon :icon="['fas', 'sync-alt']" class="lg"/>
            </a> to get the most current data.
          </div>
          <div class="activity-summary">
            <div class="activity-element">
              <font-awesome-icon
                :icon="['fal', 'spinner']"
                size="lg"
                class="ml-1 mr-1"/>
              Generating
            </div>
            <div class="activity-element">
              <font-awesome-icon
                :icon="['fas', 'clock']"
                size="lg"
                class="ml-1 mr-1 text-muted"/>
                {{ reportData.startDate | formatDateMMDDYYYYHHMM }}
            </div>
          </div>
        </div>
        <div v-else class="activity-summary">
          <div class="activity-status activity-element">
            <span class="has-text-weight-bold">
              No CEP Roster CSV has been generated this week.
            </span>
          </div>
        </div>
      </div>
    </div>
    <iframe ref="downloadFrame" title="Download - Extract File"></iframe>
  </div>
</template>

<script>
import axios from 'axios';
import EsException from '@/components/EsException.vue';
import EsLoader from '@/components/EsLoader.vue';
import moment from 'moment';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faArrowCircleDown,
  faSpinner,
} from '@fortawesome/pro-light-svg-icons';
import {
  faClipboardUser,
  faClock,
  faSyncAlt,
} from '@fortawesome/pro-solid-svg-icons';

import EsHeader from '@/components/EsHeader.vue';

library.add(
  faArrowCircleDown,
  faClipboardUser,
  faClock,
  faSpinner,
  faSyncAlt,
);

export default {
  components: {
    EsException,
    EsHeader,
    EsLoader,
  },
  props: {
    locationGroupId: {
      type: [String, Number],
    },
    schoolYear: {
      type: Number,
    },
  },
  data() {
    return {
      loading: true,
      loadingError: false,
      reportData: null,
      reportType: 'CEP_ROSTER',
    };
  },
  async created() {
    await this.getLatestCepRosterReport();
  },
  computed: {
    urlParams() {
      const params = {};
      params.locationGroupId = this.locationGroupId;
      params.pageSize = 1;
      params.reportType = this.reportType;
      params.schoolYear = this.schoolYear;
      params.startDate = moment().subtract(7, 'days').format('YYYY-MM-DD');
      return params;
    },
  },
  methods: {
    async getLatestCepRosterReport() {
      try {
        this.setBusy(true);
        this.loadingError = false;
        const response = await axios
          .get('reports/user-generated',
            {
              params: this.urlParams,
            });
        this.reportData = response.data.data.length ? response.data.data[0] : null;
        this.$emit('onRefreshMyActivity', !this.reportData || (this.reportData && this.reportData.endDate));
      } catch (e) {
        this.loadingError = true;
      } finally {
        this.setBusy(false);
      }
    },
    setBusy(loading) {
      this.loading = loading;
    },
    formatDateMMDDYYYYHH(value) {
      if (value) {
        return moment(value).format('MM/DD/YYYY HH:mm');
      }
      return 'N/A';
    },
    downloadReport() {
      this.$refs.downloadFrame.src = `${axios.defaults.baseURL}reports/${this.reportType}/${this.reportData.id}/download`;
    },
  },
  watch: {
    $route() {
      this.getLatestCepRosterReport();
    },
  },
};

</script>

<style lang="sass" scoped>
  .text-muted
    color: #6c757d !important
  .activity-row
    border-top: 1px solid rgb(222, 226, 230)
  .activity-row-container
    padding: .5rem 1rem
    display: flex
  .icon-column
    min-width: 40px
    display: flex
    align-items: flex-start
  .activity-summary
    font-size: .85rem
    display: flex
    flex-direction: column
    align-items: flex-start
  .activity-element
    padding-top: 4px
    padding-bottom: 4px
    text-align: left
  .activity-status
    text-align: left
  .ml-1
    margin-left: .25rem
  .mr-1
    margin-right: .25rem
  iframe
    display: none
</style>
